export default {
    headerBackgroundColor: '#7DD420'
}